
import "leaflet/dist/leaflet.css"
import { mdiMapMarker } from "@mdi/js"

import {
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
    LControlZoom,
    LIcon,
} from "vue2-leaflet"
import OImage from "@/components/base/image/OImage"

export default {
    name: "StadiaMap",
    components: {
        LIcon,
        OImage,
        "l-map": LMap,
        "l-marker": LMarker,
        "l-circle": LCircle,
        "l-tile-layer": LTileLayer,
        "l-control-zoom": LControlZoom,
    },
    props: {
        /**
         * An array with marker objects:
         * id: String
         * lat: Latitude
         * long: Longitude
         * name: String - A image alternative text
         * iconSrc: String - The displayed image for the marker
         */
        markers: {
            default: () => [],
            type: Array,
        },
        /**
         * Array of two numbers
         * x, y Coordinate of the center
         */
        center: {
            default: () => [],
            type: Array,
        },
        zoom: {
            type: Number,
            default: 14,
        },
        markerSize: {
            type: Number,
            default: 80,
        },
        markerSizeMobile: {
            type: Number,
            default: 60,
        },
        radius: {
            type: Number,
            default: 0,
        },
        minZoom: {
            type: Number,
        },
        maxZoom: {
            type: Number,
        },
        /** A highlighted marker representing the users position */
        yourLocation: {
            type: Object,
            default: null,
        },
        rounded: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            mdiMapMarker,
            loadDynamic: false,
            url: "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png",
            attribution:
                '&copy; <a rel="nofollow" href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a rel="nofollow" href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a rel="nofollow" href="http://openstreetmap.org">OpenStreetMap</a> contributors',
        }
    },
    computed: {
        iconSize() {
            let size = this.markerSize
            if (this.$breakpoint.smAndDown) {
                size = this.markerSizeMobile
            }
            return size
        },
    },
    methods: {
        updateBounds(bounds) {
            this.$emit("update:map-bounds", bounds)
        },
        updateCenter(center) {
            this.$emit("update:map-center", center)
        },
        updateZoom(zoomLevel) {
            this.$emit("update:map-zoom", zoomLevel)
        },
        clickAt(marker) {
            if (!marker.clickFunction) {
                return
            }
            marker.clickFunction()
        },
    },
}
